"use strict";
/**
 * Date/time formatting utilities
 *
 * Lambda runs in the UTC timezone, so relying on Date#getFullYear() /
 * getHours() etc. produces UTC-based strings. These helpers explicitly format
 * in Japan Standard Time (Asia/Tokyo) so that email bodies and other
 * user-facing strings match what the frontend displays.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateTimeJST = formatDateTimeJST;
const JST_TIME_ZONE = 'Asia/Tokyo';
/**
 * Format an ISO 8601 date string as a Japanese date/time in JST.
 *
 * Example: "2026-06-10T00:30:00.000Z" -> "2026年6月10日 9:30"
 *
 * @param isoString ISO 8601 date string (typically stored in UTC)
 * @returns Japanese formatted date/time string in JST
 */
function formatDateTimeJST(isoString) {
    const date = new Date(isoString);
    // Intl.DateTimeFormat with timeZone reliably converts to JST regardless of
    // the runtime's local timezone (UTC on Lambda).
    const parts = new Intl.DateTimeFormat('ja-JP', {
        timeZone: JST_TIME_ZONE,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).formatToParts(date);
    const get = (type) => parts.find((p) => p.type === type)?.value ?? '';
    const year = get('year');
    const month = get('month');
    const day = get('day');
    // hour is zero-padded ('2-digit'); strip a single leading zero to keep the
    // existing "9:30" style (not "09:30") for the hour while minutes stay padded.
    const hour = get('hour').replace(/^0/, '');
    const minute = get('minute');
    return `${year}年${month}月${day}日 ${hour}:${minute}`;
}
//# sourceMappingURL=datetime.js.map